import { DriverDetails } from "../../types";

export const mergeDriversDetails = (drivers: DriverDetails[]) => {
  return drivers.reduce((finalDriver, currentDriver) => {
    const finalDriverData = finalDriver.driverData;
    const currentDriverData = currentDriver.driverData;
    return {
      driverMenuItemTitle: drivers[0].driverMenuItemTitle,
      steps: [],
      driverData: {
        driverHeader: drivers[0].driverData.driverHeader,
        stepsData: [
          ...finalDriverData.stepsData,
          ...currentDriverData.stepsData,
        ],
        customSkip: () => {
          finalDriverData.customSkip && finalDriverData.customSkip();
          currentDriverData.customSkip && currentDriverData.customSkip();
        },
      },
    } as DriverDetails;
  });
};
